import * as React from "react";
import { useState } from "react";
import { PortfolioList } from "~/sharedComponents/portfolioList";

export const PortfolioDropdown: typeof PortfolioList = ({
    value: initValue,
    onChangeAction: changeFieldValue,
    emptyOption,
}) => {
    const [value, setValue] = useState(initValue);
    const onChangeAction = (value: number) => {
        setValue(value);
        changeFieldValue(value);
    };

    return (
        <PortfolioList
            value={value}
            onChangeAction={onChangeAction}
            emptyOption={emptyOption}
            selectTriggerPlaceholder={emptyOption.label}
            canCreate={false}
            isLoading={false} // not to reload portfolios if selected one is missing in options
            theme={null}
            disableAutoReset={true}
        />
    );
};
